import React, { useEffect, useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import {
  applyCouponApi,
  get_paymentKey,
  getCouponAndDeliveryApi,
  getCoupons,
  getUser,
  glbGetSize,
  orderValidate,
  PaymentAdd,
  PlaceOrder,
} from "../../Services/Operations/ProductAPI";
import "../../Styles/CheckOut.css";
import {
  deleteAllCart,
  deleteAllGlbItems,
  deleteEntireProductItems,
  setSelectedAddressId,
} from "../../Redux/Cart_System";
import { loadStripe } from "@stripe/stripe-js";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { get_countryList, addUser } from "../../Services/Operations/ProductAPI";
import CustomDropdown from "../AccountSec/CustomDropdown";

const AddAddressModal = ({ isOpen, onClose, onAddressAdded }) => {
  const { tokenDetails, totalItems } = useSelector((state) => state.user);
  const token = tokenDetails;

  const [country, setCountry] = useState([]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await get_countryList();
        if (response.success === true) {
          setCountry(response.data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountry();
  }, []);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("mobile_no", data.mobile_no);
      formData.append("address", data.address);
      formData.append("city", data.city);
      formData.append("state", data.state);
      formData.append("country", data.country);
      formData.append("pincode", data.pincode);

      const result = await addUser(data, token);
      if (result.success === true) {
        toast.success("Address added successfully!");
        onAddressAdded();
        onClose();
        reset();
      }
    } catch (error) {
      console.error("Error adding address:", error);
      //toast.error("Failed to add address. Please try again.");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          maxWidth: "600px",
          width: "90%",
          margin: "auto",
          borderRadius: "8px",
          padding: "20px",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
        },
      }}
    >
      <div style={{ position: "relative" }}>
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-10px",
            right: "-10px",
            background: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ×
        </button>

        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Add New Address
        </h3>

        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="Full name"
            {...register("name", { required: "Full name is required" })}
          />
          {errors.name && (
            <p style={{ color: "red", margin: 0 }}>{errors.name.message}</p>
          )}

          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="Phone Number"
            {...register("mobile_no", { required: "Phone number is required" })}
          />
          {errors.mobile_no && (
            <p style={{ color: "red", margin: 0 }}>
              {errors.mobile_no.message}
            </p>
          )}

          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="Address"
            {...register("address", { required: "Address is required" })}
          />
          {errors.address && (
            <p style={{ color: "red", margin: 0 }}>{errors.address.message}</p>
          )}

          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="City"
            {...register("city", { required: "City is required" })}
          />
          {errors.city && (
            <p style={{ color: "red", margin: 0 }}>{errors.city.message}</p>
          )}

          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="State"
            {...register("state", { required: "State is required" })}
          />
          {errors.state && (
            <p style={{ color: "red", margin: 0 }}>{errors.state.message}</p>
          )}

          <CustomDropdown
            options={country}
            onSelect={(value) => setValue("country", value)}
            register={register}
            name="country"
            errors={errors}
          />

          <input
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            type="text"
            placeholder="Zip Code"
            {...register("pincode", { required: "Zip code is required" })}
          />
          {errors.pincode && (
            <p style={{ color: "red", margin: 0 }}>{errors.pincode.message}</p>
          )}

          <button
            type="submit"
            style={{
              padding: "12px",
              backgroundColor: "black",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Save Address
          </button>
        </form>
      </div>
    </Modal>
  );
};

const SkeletonLoader = () => {
  return (
    <div style={skeletonStyles.container}>
      {/* Header Skeleton */}
      <div style={skeletonStyles.header}></div>

      {/* Two-column layout skeleton */}
      <div style={skeletonStyles.columnsContainer}>
        {/* Left column (cart items) */}
        <div style={skeletonStyles.column}>
          <div style={skeletonStyles.sectionTitle}></div>
          {[...Array(2)].map((_, i) => (
            <div key={i} style={skeletonStyles.cartItem}>
              <div style={skeletonStyles.cartImage}></div>
              <div style={skeletonStyles.cartDetails}>
                <div style={skeletonStyles.textLine}></div>
                <div style={skeletonStyles.textLineShort}></div>
                <div style={skeletonStyles.textLineMedium}></div>
              </div>
            </div>
          ))}
          <div style={skeletonStyles.priceSummary}>
            <div style={skeletonStyles.priceRow}></div>
            <div style={skeletonStyles.priceRow}></div>
            <div style={skeletonStyles.priceRow}></div>
          </div>
        </div>

        {/* Right column (address and payment) */}
        <div style={skeletonStyles.column}>
          <div style={skeletonStyles.addressSection}>
            <div style={skeletonStyles.sectionTitle}></div>
            {[...Array(2)].map((_, i) => (
              <div key={i} style={skeletonStyles.addressCard}></div>
            ))}
            <div style={skeletonStyles.addButton}></div>
          </div>

          <div style={skeletonStyles.paymentSection}>
            <div style={skeletonStyles.sectionTitle}></div>
            <div style={skeletonStyles.paymentOptions}>
              <div style={skeletonStyles.radioOption}></div>
              <div style={skeletonStyles.radioOption}></div>
            </div>
            <div style={skeletonStyles.paymentElement}></div>
            <div style={skeletonStyles.payButton}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const skeletonStyles = {
  container: {
    padding: "20px",
    maxWidth: "1460px",
    margin: "auto",
  },
  header: {
    height: "40px",
    width: "200px",
    backgroundColor: "#e0e0e0",
    margin: "0 auto 30px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  columnsContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  column: {
    flex: 1,
    minWidth: "280px",
  },
  sectionTitle: {
    height: "24px",
    width: "150px",
    backgroundColor: "#e0e0e0",
    marginBottom: "15px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  cartItem: {
    display: "flex",
    padding: "15px",
    marginBottom: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
  },
  cartImage: {
    width: "80px",
    height: "80px",
    backgroundColor: "#e0e0e0",
    marginRight: "15px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  cartDetails: {
    flex: 1,
  },
  textLine: {
    height: "16px",
    width: "100%",
    backgroundColor: "#e0e0e0",
    marginBottom: "8px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  textLineShort: {
    height: "16px",
    width: "70%",
    backgroundColor: "#e0e0e0",
    marginBottom: "8px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  textLineMedium: {
    height: "16px",
    width: "85%",
    backgroundColor: "#e0e0e0",
    marginBottom: "8px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  priceSummary: {
    backgroundColor: "#f5f5f5",
    padding: "15px",
    borderRadius: "8px",
    marginTop: "15px",
  },
  priceRow: {
    height: "20px",
    width: "100%",
    backgroundColor: "#e0e0e0",
    marginBottom: "10px",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  addressSection: {
    backgroundColor: "#f5f5f5",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px",
  },
  addressCard: {
    height: "80px",
    backgroundColor: "#e0e0e0",
    margin: "10px 0",
    borderRadius: "8px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  addButton: {
    height: "40px",
    width: "160px",
    backgroundColor: "#e0e0e0",
    borderRadius: "33px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  paymentSection: {
    backgroundColor: "#f5f5f5",
    padding: "15px",
    borderRadius: "8px",
  },
  paymentOptions: {
    display: "flex",
    gap: "15px",
    marginBottom: "15px",
  },
  radioOption: {
    height: "24px",
    width: "120px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  paymentElement: {
    height: "40px",
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    marginBottom: "15px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
  payButton: {
    height: "50px",
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: "33px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
};

const globalStyles = `
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

const Checkout = () => {
  const { baseAssetUrl } = useSelector((state) => state.cart);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [paymentMethod, setPaymentMethod] = useState("online");
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const {
    product,
    remainingProductItems,
    glb,
    remainingGlbItems,
    totalPrice1,
    discountAmount,
    quantityDiscountAmount,
    payableAmount,
  } = location.state || {};

  console.log("stripePromise", stripePromise);

  console.log("product :", product);
  console.log("glb :", glb);
  console.log("totalPrice1 :", totalPrice1);
  console.log("discountAmount :", discountAmount);
  console.log("payableAmount :", payableAmount);
  console.log("remainingGlbItems :", remainingGlbItems);

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [street, setStreet] = useState("");
  const [addressLine, setAddressLine] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);
  const [order, setOrder] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const { configUrl } = useSelector((state) => state.cart);
  console.log("configUrl : ", configUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [payablePrice, setpayablePrice] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);

  const { tokenDetails } = useSelector((state) => state.user);
  const token = tokenDetails;

  const productTotal = product.reduce((sum, productItem) => {
    return (
      sum +
      productItem.data.reduce(
        (dataSum, prod) => dataSum + prod.qty * productItem.product_price,
        0
      )
    );
  }, 0);
  console.log(productTotal);

  const glbTotal = glb.reduce((sum, productItem) => {
    return (
      sum +
      productItem.data.reduce(
        (dataSum, prod) => dataSum + prod.qty * prod.price,
        0
      )
    );
  }, 0);

  console.log("glbTotal : ", glbTotal);

  const totalPrice = productTotal + glbTotal;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    setpayablePrice(totalPrice);

    return () => clearTimeout(timer);
  }, []);

  const handleGetCoupon = async () => {
    try {
      const response = await getCoupons(token);
      console.log("coupon list", response.data);
      setCouponList(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const refreshAddresses = async () => {
    try {
      const response = await getUser(token);
      if (response.success) {
        setAddresses(response.data);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  const [sizeAll, setSize] = useState([]);
  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await glbGetSize();
        console.log("fetch size : ", response);
        if (response.success) {
          setSize(response.data);
        }
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };
    setpayablePrice(totalPrice);
    fetchSize();
  }, []);

  useEffect(() => {
    if (location.state && location.state.couponCode) {
      setCouponCode(location.state.couponCode);
    }
  }, [location.state]);

  useEffect(() => {
    console.log("couponCode updated: ", couponCode);
  }, [couponCode]);

  const [selectedId, setSelectedId] = useState(null);
  const [mobile, setmobile] = useState(window.innerWidth < 567 ? true : false);

  const totalQuantity =
    product.reduce((sum, productItem) => {
      return (
        sum + productItem.data.reduce((dataSum, prod) => dataSum + prod.qty, 0)
      );
    }, 0) + glb.reduce((sum, productItem) => {
      return (
        sum + productItem.data.reduce((dataSum, prod) => dataSum + prod.qty, 0)
      );
    }, 0);

  const handleClick = (id) => {
    setSelectedId(id);
    console.log("id : ", id);
    dispatch(setSelectedAddressId(id));
  };

  const handleGetCouponDelivery = async () => {
    try {
      const response = await getCouponAndDeliveryApi(token, totalQuantity);
      console.log("delivery charge", response);

      setDeliveryCharge(response.data.data.delivery);
      setpayablePrice(totalPrice + Number(response.data.data.delivery));

      if (response.data.errorcode === "00") {
        setSelectedCoupon(response.data.data.coupon.code);
        setCouponDiscount(
          Number(
            response.data.data.coupon.quantity_discounts[0].discount_percentage
          )
        );
        setpayablePrice(
          totalPrice +
          Number(response.data.data.delivery) -
          (Number(
            response.data.data.coupon.quantity_discounts[0]
              .discount_percentage
          ) *
            totalPrice) /
          100
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUser(token);
        console.log("address :", response);
        if (response.success) {
          setAddresses(response.data);
          setSelectedId(response.data[0]?.id);
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        //toast.error("An error occurred while fetching addresses.");
      }
    };

    fetchData();
    handleGetCoupon();
    handleGetCouponDelivery();
  }, []);

  if (isLoading) {
    return (
      <>
        <style>{globalStyles}</style>
        <SkeletonLoader />
      </>
    );
  }
  const handlePay = async () => {
    setPaymentModalOpen(true);
  };

  const handleError = (error) => {
    console.error("Payment Error:", error);
  };

  const handleOk = async (event) => {
    setLoading(true);
    setPaymentModalOpen(false);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    if (paymentMethod === "COD") {
      const formData = new FormData();
      console.log("Product in payment: ", product);
      console.log("glb in payment: ", glb);
      const filteredCartData = product.flatMap((item) =>
        item.data.map((size) => ({
          product_id: item.product_id,
          size_id: size.size_id,
          quantity: size.qty,
          name: size.name,
          number: size.number,
        }))
      );
      const filteredGlbData = glb.flatMap((item) =>
        item.data.map((size) => ({
          product_id: item.glb_id,
          size_id: size.size_id,
          quantity: size.qty,
          name: size.name,
          number: size.number,
        }))
      );

      console.log("cart data : ", filteredCartData);
      console.log("glb data : ", filteredGlbData);
      console.log("selectedId : ", selectedId);

      console.log("remainingGlbItems : ", remainingGlbItems);
      console.log("remainingProductItems : ", remainingProductItems);

      let logoKey = null;
      const transformedData = [
        ...glb.map((item) => {
          return {
            cart_id: item.cart_id,
            data: item.data.map((dataItem) => ({
              id: dataItem.id,
              category: dataItem.category ? dataItem.category : "",
              name: dataItem.name,
              number: dataItem.number,
              size_id: dataItem.size_id,
              qty: dataItem.qty,
              price: dataItem.price,
            })),
          };
        }),

        ...product.map((item) => {
          let logoFile = null;
          if (item?.logo_base64) {
            const byteString = atob(item.logo_base64.split(",")[1]);
            const mimeString = item.logo_base64
              .split(",")[0]
              .split(":")[1]
              .split(";")[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            const logoFile = new File([blob], "logo.png", { type: mimeString });

            logoKey = `logo_${item.cart_id}`;
            formData.append(logoKey, logoFile);
          }
          console.log("logoFile : ", logoFile);
          console.log("item : ", item);
          return {
            cart_id: item.cart_id,
            // logo: logoKey,
            styles: item.styles ? item.styles : [],
            sponsor_name: item?.sponsor_name,
            special_requests: item?.special_requests,
            order_type: item?.orderType,
            data: item.data.map((dataItem) => ({
              id: dataItem.id,
              name: dataItem.name,
              category: dataItem.category ? dataItem.category : "",
              number: dataItem.number,
              size_id: dataItem.size_id,
              qty: dataItem.qty,
              price: item.product_price,
              color_id: dataItem.color_id,
            })),
          };
        }),
      ];

      console.log("transformedData : ", transformedData);

      formData.append("cartData", JSON.stringify(transformedData));
      formData.append("couponCode", couponCode);
      formData.append("orderType", "NORMAL");
      formData.append("paymentType", paymentMethod);
      formData.append("created_by", "WEB");
      formData.append("addressId", selectedId);
      formData.append("couponCode", selectedCoupon);

      try {
        const placeOrderResponse = await PlaceOrder(formData, token);
        console.log("placeOrderResponse : ", placeOrderResponse);
        if (placeOrderResponse.success === true) {
          setPaymentModalOpen(false);
          toast.success("Order is completed");
          dispatch(deleteAllGlbItems());
          dispatch(deleteEntireProductItems());
          navigate("/orderHistory");
        } else {
          //toast.error("select address and paymentType!");
          setPaymentModalOpen(false);
        }
      } catch (error) {
        console.error("Error submitting order:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setPaymentModalOpen(false);
      event.preventDefault();

      if (!stripe || !elements) {
        console.error("Stripe or elements not initialized");
        setLoading(false);
        return;
      }

      setLoading(true);

      // Submit payment details to Stripe
      const { error: submitError } = await elements.submit();
      if (submitError) {
        console.error("Submit Error:", submitError);
        //toast.error(`Payment details error: ${submitError.message}`);
        setLoading(false);
        return;
      }

      // Fetch clientSecret from backend
      let clientSecret;
      try {
        if (!selectedId) {
          //toast.error("Please select an address first.");
          setLoading(false);
          return;
        }

        const formData = new FormData();
        formData.append("addressId", selectedId);
        formData.append("amount", payablePrice.toFixed(2));

        const response = await get_paymentKey(formData, token);
        console.log("Full API Response:", response);

        if (!response?.data?.clientSecret) {
          throw new Error("Invalid response: clientSecret missing!");
        }

        clientSecret = response.data.clientSecret;
        console.log("Extracted Client Secret:", clientSecret);
      } catch (error) {
        console.error("Error fetching payment key:", error);
        //toast.error("Failed to initialize payment. Please try again.");
        setLoading(false);
        return;
      }

      const orderData = {
        product: product,
        glb: glb,
        selectedId: selectedId,
        payablePrice: payablePrice,
        couponCode: selectedCoupon || couponCode,
      };

      // Confirm payment with Stripe
      sessionStorage.setItem("pendingOrderData", JSON.stringify(orderData));

      // Then proceed with Stripe confirmation
      try {
        const { error } = await stripe.confirmPayment({
          elements,
          clientSecret,
          confirmParams: {
            return_url: `${window.location.origin}/verify-payment`,
          },
        });

        if (error) {
          console.error("Payment Error:", error);
          toast.error(`Payment failed: ${error.message}`);
          // Clear stored data on error
          sessionStorage.removeItem("pendingOrderData");
        } else {
          console.log("Payment Successful! Waiting for verification...");
          toast.success("Payment successful! Redirecting...");
          // Don't clear sessionStorage here - let PaymentSuccess handle it
        }
      } catch (error) {
        console.error("Stripe Confirmation Error:", error);
        //toast.error("Payment confirmation failed. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  console.log("product : ", product);

  const handleApplyCoupon = async (coupon) => {
    // Find the coupon object
    const couponObj = couponList.find(c => c.code === coupon);

    // Check if coupon is applicable based on total price
    if (couponObj && totalPrice < couponObj.required_amount) {
      toast.error(`Minimum order amount required: $${couponObj.required_amount} for coupon ${coupon}`);
      return;
    }

    const data = new FormData();
    data.append("couponCode", coupon);
    data.append("totalAmount", totalPrice);
    data.append("totalQuantity", totalQuantity);
    try {
      const respnse = await applyCouponApi(data, token);
      console.log(respnse);
      if (respnse.data.errorcode !== "00") {
        toast.error(respnse.data.message);
        return;
      }
      console.log(respnse.data.data[0].discountAmount);

      // For flat amount coupons, calculate the percentage discount
      const discountAmount = respnse.data.data[0].discountAmount;
      const discountPercentage = (discountAmount / totalPrice) * 100;

      setCouponDiscount(discountPercentage);
      setpayablePrice(
        totalPrice +
        Number(deliveryCharge) -
        Number(discountAmount)
      );
      toast.info(respnse.data.data[0].description);
      setSelectedCoupon(coupon);
    } catch (error) {
      console.log(error);
      toast.error("Failed to apply coupon");
    }
  };

  return (
    <div>
      <div
        style={{
          padding: "20px",
          maxWidth: "1460px",
          margin: "auto",
          color: "#333",
          paddingTop: mobile ? "120px" : "140px",
        }}
      >
        <p
          style={{
            color: "#333",
            textAlign: "center",
            borderBottom: "3px solid grey",
            paddingBottom: "10px",
            fontSize: "1.9rem",
            fontWeight: "800",
            fontFamily: "Poppins",
          }}
        >
          Checkout
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            marginTop: "20px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              flex: "1",
              minWidth: "280px",
              padding: "15px",
              borderRadius: "10px",
            }}
          >
            <p
              className="middle1"
              style={{
                color: "#333",
                marginBottom: "10px",
                fontWeight: "bold",
                fontSize: "1.6rem",
                fontFamily: "Poppins",
              }}
            >
              Cart Items
            </p>
            {product.map((item) => (
              <div
                key={item.id}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  padding: "15px 0px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  src={`${item.product_image}`}
                  alt={item.product_name}
                  className="checkout_product_image"
                  style={{
                    marginRight: "10px",

                    borderRadius: "8px",
                  }}
                />

                <div style={{ width: "86%" }}>
                  <p
                    style={{
                      margin: "0 0 5px",
                      color: "#333",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "92%",
                      fontSize: "1.14rem",
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.product_name}
                  </p>

                  {item.data.map((prod, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#f9f9f9",
                        padding: "10px",
                        borderRadius: "8px",
                        marginBottom: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(140px, 1fr))",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div>
                        <strong>Size:</strong>{" "}
                        {sizeAll.find((size) => size.id === prod.size_id)
                          ?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Quantity:</strong> {prod.qty}
                      </div>
                      <div>
                        <strong>Price:</strong> ${item.product_price.toFixed(2)}
                      </div>
                      {prod.name && (
                        <div>
                          <strong>Name:</strong> {prod.name}
                        </div>
                      )}
                      {prod.number && (
                        <div>
                          <strong>Number:</strong> {prod.number}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {glb.map((item) => (
              <div
                key={item.cart_id}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  padding: "15px 0px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  src={`${baseAssetUrl}${item.glb_image}`}
                  alt={item.name}
                  className="checkout_product_image"
                  style={{
                    marginRight: "10px",
                    borderRadius: "8px",
                  }}
                  onError={(e) => {
                    e.target.src = `${baseAssetUrl}${item.image}`;
                  }}
                />

                <div style={{ width: "86%" }}>
                  <p
                    style={{
                      margin: "0 0 5px",
                      color: "#333",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "92%",
                      fontSize: "1.14rem",
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.name}
                  </p>

                  {item.data?.map((prod, index) => (
                    <div
                      key={`${item.cart_id}-${prod.id || index}`}
                      style={{
                        backgroundColor: "#f9f9f9",
                        padding: "10px",
                        borderRadius: "8px",
                        marginBottom: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(140px, 1fr))",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div>
                        <strong>Size:</strong>{" "}
                        {sizeAll.find((size) => size.id === prod.size_id)
                          ?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Quantity:</strong> {prod.qty || 0}
                      </div>
                      <div>
                        <strong>Price:</strong> ${(prod.price || 0).toFixed(2)}
                      </div>
                      {prod.name && (
                        <div>
                          <strong>Name:</strong> {prod.name}
                        </div>
                      )}
                      {prod.number && (
                        <div>
                          <strong>Number:</strong> {prod.number}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div style={styles.container}>
              <p style={{ fontSize: "20px", fontWeight: "700" }}>
                Available Coupon
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                {couponList.map((c) => {
                  // Check if totalPrice meets the required_amount condition
                  const isCouponApplicable = totalPrice >= c.required_amount;

                  return (
                    <p
                      onClick={() => {
                        if (isCouponApplicable) {
                          handleApplyCoupon(c.code);
                        }
                      }}
                      style={{
                        padding: "7px",
                        borderRadius: "10px",
                        border: "1px solid gray",
                        fontWeight: "700",
                        cursor: isCouponApplicable ? "pointer" : "not-allowed",
                        backgroundColor: isCouponApplicable
                          ? selectedCoupon === c.code
                            ? "#aaa8a8ff"
                            : "#d3d1d1ff"
                          : "#f0f0f0", // Gray out if not applicable
                        color: isCouponApplicable
                          ? selectedCoupon === c.code
                            ? "#000000ff"
                            : "#7e7e7eff"
                          : "#a0a0a0", // Light text if not applicable
                        opacity: isCouponApplicable ? 1 : 0.6,
                      }}
                      title={!isCouponApplicable ? `Minimum order amount required: $${c.required_amount}` : c.description}
                    >
                      {c.code}
                      {!isCouponApplicable && (
                        <span style={{ fontSize: "0.8em", display: "block", marginTop: "2px" }}>
                          (Min: ${c.required_amount})
                        </span>
                      )}
                    </p>
                  );
                })}
              </div>
            </div>

            <div style={styles.container}>
              <p style={styles.row}>
                <span style={styles.label}>Total Price:</span>
                <span style={styles.value}>${totalPrice.toFixed(2)}</span>
              </p>
              <p style={styles.row}>
                <span style={styles.label}>Total Items:</span>
                <span
                  style={{
                    ...styles.value,
                    fontWeight: "400",
                    color: "#3b3b3bff",
                  }}
                >
                  {totalQuantity}
                </span>
              </p>
              {/* <p style={styles.row}>
  <span style={styles.label}>Coupon Discount:</span>
  <span
    style={{
      ...styles.value,
      color: discountAmount ? "#ff4d4f" : "#555",
    }}
  >
    $ {((couponDiscount * totalPrice) / 100).toFixed(2)} ({couponDiscount.toFixed(2)}%)
  </span>
</p> */}
              <p style={styles.row}>
                <span style={styles.label}>Coupon Discount:</span>
                <span
                  style={{
                    ...styles.value,
                    color: discountAmount ? "#ff4d4f" : "#555",
                  }}
                >
                  {couponList.find(c => c.code === selectedCoupon)?.flat_amount ? (
                    // For flat amount coupons
                    <>$ {((couponList.find(c => c.code === selectedCoupon)?.flat_amount || 0)).toFixed(2)} (Flat)</>
                  ) : (
                    // For percentage coupons
                    <>$ {((couponDiscount * totalPrice) / 100).toFixed(2)} ({couponDiscount.toFixed(2)}%)</>
                  )}
                </span>
              </p>
              <p style={styles.row}>
                <span style={styles.label}>Delivery Charge:</span>
                <span
                  style={{
                    ...styles.value,
                    color: discountAmount ? "#ff4d4f" : "#555",
                  }}
                >
                  ${deliveryCharge}
                </span>
              </p>
              <p style={styles.row}>
                <span style={styles.label}>Payable Amount:</span>
                <span
                  style={{
                    ...styles.value,
                    fontWeight: "bold",
                    color: "#28a745",
                  }}
                >
                  ${payablePrice}
                </span>
              </p>
            </div>
          </div>

          <div
            style={{
              flex: "1",
              minWidth: "280px",
            }}
          >
            <div
              style={{
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                padding: "15px",
                borderRadius: "10px",
                marginTop: "54px",
              }}
            >
              <p
                style={{
                  color: "#333",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  fontFamily: "Poppins",
                }}
              >
                Delivery Address
              </p>
              <div style={{ margin: "0px" }}>
                {addresses.map((item) => (
                  <div
                    className="deliveryAddress"
                    key={item.id}
                    onClick={() => handleClick(item.id)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "15px 7px",
                      margin: "10px 0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      backgroundColor:
                        selectedId === item.id ? "#d9f7ff" : "#f8f9fa",
                      border:
                        selectedId === item.id
                          ? "2px solid #00bcd4"
                          : "1px solid #e0e0e0",
                      // boxShadow:
                      //   selectedId === item.id
                      //     ? "0 4px 8px rgba(0, 188, 212, 0.3)"
                      //     : "0 2px 4px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <div style={{ fontWeight: "bold", color: "#333" }}>
                      {item.name}
                    </div>
                    <div
                      style={{ flexGrow: 1, marginLeft: "13px", color: "#555" }}
                    >
                      {item.address}, {item.city},{item.state},{item.country},{" "}
                      {item.pincode}
                    </div>
                    <div style={{ fontWeight: "bold", color: "#007bff" }}>
                      {item.mobile_no}
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="add-btn1"
                onClick={() => setIsAddressModalOpen(true)}
                style={{ backgroundColor: "black", borderRadius: "33px" }}
              >
                + Add New Address
              </button>
            </div>
            <div
              style={{
                marginTop: "20px",
                padding: "15px",
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <p
                style={{
                  marginBottom: "10px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                Pay and Order
              </p>
              <div style={{ display: "flex", gap: "15px" }}></div>
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <PaymentElement />
              <button
                type="button"
                onClick={() => setPaymentModalOpen(true)}
                style={{
                  marginTop: "44px",
                  padding: "17px",
                  width: "100%",
                  backgroundColor: "black",
                  borderRadius: "33px",
                  fontSize: "20px",
                  color: "#fff",
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontWeight: "bold",
                  opacity: !stripe || !elements || loading ? 0.7 : 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                disabled={!stripe || !elements || loading}
              >
                {loading ? (
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      border: "3px solid rgba(255, 255, 255, 0.3)",
                      borderTopColor: "#fff",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                ) : (
                  "Proceed to Pay"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {isPaymentModalOpen && (
        <div className="payment-modal">
          <div className="payment-modal-content">
            <h2>Order Successful!</h2>
            <p>Your order is ready to be Proceed.</p>
            <button onClick={handleOk} className="pay-now-btn">
              Ok
            </button>
            <button
              onClick={() => {
                setPaymentModalOpen(false);
                setOrder(false);
              }}
              className="close-btn"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <AddAddressModal
        isOpen={isAddressModalOpen}
        onClose={() => setIsAddressModalOpen(false)}
        onAddressAdded={refreshAddresses}
      />
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  margin: "8px 0",
  borderRadius: "8px",
  border: "1px solid #ddd",
  boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
};
const styles = {
  container: {
    width: "100%",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    // margin: "20px auto",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    // maxWidth: "500px",
    // fontFamily: "Arial, sans-serif",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    fontSize: "16px",
  },
  label: {
    fontWeight: "bold",
    color: "#555",
  },
  value: {
    color: "#333",
  },
};

export default Checkout;
